import React, { useState, useEffect, useCallback } from "react";

const BranchRejected = ({ branchId, auth, transactions }) => {
  const [rejectedTxs, setRejectedTxs] = useState([]);
  const [loading, setLoading] = useState(false);
  const API_URL = `https://${process.env.REACT_APP_API_KEY_TRANS}.execute-api.ap-south-1.amazonaws.com/default/branchTransaction`;

  const fetchRejected = useCallback(async () => {
    if (!branchId) return;
    setLoading(true);
    try {
      const response = await fetch(API_URL);
      const data = await response.json();

      const all = data.transactions || [];

      // 1. Calculate Today and Yesterday strings (YYYY-MM-DD)
      const today = new Date();
      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);

      const todayStr = today.toISOString().split("T")[0];
      const yesterdayStr = yesterday.toISOString().split("T")[0];

      // 2. Apply the strict Triple Filter
      const filtered = all.filter((tx) => {
        // A. Check Status
        const isRejected = String(tx.status).toUpperCase() === "REJECTED";

        // B. Check Branch Ownership
        const isMyBranch =
          tx.fromBranch === branchId || tx.toBranch === branchId;

        // C. Check Date (Today or Yesterday)
        const txDate = tx.timestamp?.split("T")[0];
        const isRecent = txDate === todayStr || txDate === yesterdayStr;

        return isRejected && isMyBranch && isRecent;
      });

      // 3. Sort by most recent first
      setRejectedTxs(
        filtered.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)),
      );
    } catch (err) {
      console.error("Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  }, [branchId, API_URL]);

  useEffect(() => {
    fetchRejected();
  }, [fetchRejected]);

  return (
    <div className="rejected-container">
      <div className="rejected-header">
        <h2>Rejected Transactions</h2>
       
        <button onClick={fetchRejected} className="refresh-btn">
          {loading ? "Refreshing..." : "↻ Refresh"}
        </button>
      </div>

      {rejectedTxs.length === 0 && !loading ? (
        <div className="no-data">
          No rejected transactions found for this period.
        </div>
      ) : (
        <table className="rejected-table">
          <thead>
            <tr>
              <th>Date</th>

              <th>Type</th>
              <th>Partner</th>
              <th>Amount</th>
              <th>Party</th>
              <th>Remarks</th>
              <th>ID</th>
            </tr>
          </thead>
          <tbody>
            {rejectedTxs.map((tx) => (
              <tr key={tx.paymentId}>
                <td>{tx.timestamp?.split("T")[0]}</td>

                <td>
                  <span className={`badge ${tx.paymentType}`}>
                    {tx.paymentType}
                  </span>
                </td>
                <td>
                  {tx.fromBranch} to {tx.toBranch}
                </td>
                <td className="amt-cell">
                  ₹{Number(tx.amount).toLocaleString()}
                </td>
                <td>{tx.receiverName || "N/A"}</td>
                <td className="remarks-cell">
                  {tx.remarks || "No reason provided"}
                </td>
                <td className="tx-id">{tx.paymentId}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default BranchRejected;
